import styled from 'styled-components';
import {GiSpades} from 'react-icons/gi';

export const Gispades = styled(GiSpades)`
  color: #A5160A;
`
